var _line, _line2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.009,
    y1: 16.206,
    x2: 12.01,
    y2: 7.798
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.213,
    y1: 12.002,
    x2: 7.806,
    y2: 12.002
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.009,
    cy: 12.002,
    r: 9.386
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.49d81ab2c7f71ca1e87e885373f4396c.svg";
export { ForwardRef as ReactComponent };